import { messages as validation } from "vee-validate/dist/locale/en.json";
import { countryList } from "@/locales/properNouns";
import messages from "./json/en.json";

export default {
  pl: {
    word: "{n} {word} | {n} {word}s",
  },
  validation: {
    ...validation,
    credit_card: "The {_field_} field must be a valid credit card number",
    required_select: validation.required,
  },
  notificationsText: {
    liked: "{screenName} liked your post",
    followed: "{screenName} followed you",
    subscribed: "{screenName} subscribed to you for {price}",
    upgradeSubscription: "{screenName} upgrade subscription to you. Now the subscription level is {price}",
    soldPost: "{screenName} bought your post for {price}",
    soldAttachment: "{screenName} bought your attach for {price}",
    soldEvent: "{screenName} has booked your event {date} for {price}",
    eventPublished: "Upcoming event by {screenName}!",
    eventStarted: "The event has started",
    eventCancelled: "{screenName} canceled the event",
    liveInvitation: "{screenName} invites you to {type}",
  },
  ...messages,
  ...countryList,
};
